import { render } from "./vue-tags-input.vue?vue&type=template&id=2fbda277&scoped=true"
import script from "./vue-tags-input.js?vue&type=script&lang=js"
export * from "./vue-tags-input.js?vue&type=script&lang=js"

import "./vue-tags-input.scss?vue&type=style&index=0&id=2fbda277&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fbda277"

export default script